import React, { useEffect, useState } from 'react'
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from '@material-ui/core'
import { Button, Typography } from 'sputnik-ui'
import { useTranslation } from 'react-i18next'
import { useDispatch } from 'react-redux'
import { fetchReleaseNotes } from '../model/releaseNotesSlice'
import { trackReleaseEvent } from '../metrics'

const STORAGE_KEY = 'release_notes_modal'
const COOLDOWN_KEY = 'release_notes_modal_cooldown'

const ReleaseNotesWidget = () => {
  const { t } = useTranslation(['release_notes'])
  const dispatch = useDispatch()
  const [open, setOpen] = useState(false)
  const [note, setNote] = useState(null)

  useEffect(() => {
    const checkModal = async () => {
      const dismissed = localStorage.getItem(STORAGE_KEY)
      const cooldown = localStorage.getItem(COOLDOWN_KEY)

      if (dismissed) return
      if (cooldown && Date.now() - Number(cooldown) < 24 * 60 * 60 * 1000)
        return

      try {
        const items = await dispatch(fetchReleaseNotes()).unwrap()
        const criticalUnread = items.find(
          (i) => i.priority === 'critical' && !i.opened
        )
        if (criticalUnread) {
          setNote(criticalUnread)
          setOpen(true)
        }
      } catch (e) {
        // silent
      }
    }

    const timer = setTimeout(checkModal, 2000)
    return () => clearTimeout(timer)
  }, [dispatch])

  const handleClose = () => {
    setOpen(false)
    localStorage.setItem(STORAGE_KEY, 'true')
  }

  const handleRemind = () => {
    setOpen(false)
    localStorage.setItem(COOLDOWN_KEY, String(Date.now()))
    trackReleaseEvent('modal_remind', { releaseId: note?.id })
  }

  const handleOpen = () => {
    setOpen(false)
    localStorage.setItem(STORAGE_KEY, 'true')
    trackReleaseEvent('modal_open', { releaseId: note?.id })
  }

  const handleUseful = () => {
    setOpen(false)
    localStorage.setItem(STORAGE_KEY, 'true')
    trackReleaseEvent('modal_useful', { releaseId: note?.id })
  }

  if (!note) return null

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
      <DialogTitle>{note.title}</DialogTitle>
      <DialogContent>
        <Typography variant="body2" color="textSecondary">
          {note.summary}
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleRemind} variant="v2" tertiary>
          {t('release_notes:modal.remind_later', 'Напомнить позже')}
        </Button>
        <Button onClick={handleOpen} variant="v2" primary>
          {t('release_notes:modal.open', 'Открыть')}
        </Button>
        <Button onClick={handleUseful} variant="v2" tertiary>
          {t('release_notes:modal.useful', 'Было полезно')}
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default ReleaseNotesWidget
